const KEY = "gcv_cart";

export const getCart = () => {
  try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
};

const save = (items) => {
  localStorage.setItem(KEY, JSON.stringify(items));
  window.dispatchEvent(new Event("gcv-cart"));
};

export const cartCount = () => getCart().reduce((n, i) => n + (i.qty || 1), 0);

export const addToCart = (item) => {
  const items = getCart();
  const found = items.find((i) => i.product_id === item.product_id && (i.variation_id || "") === (item.variation_id || "") && JSON.stringify(i.meta || {}) === JSON.stringify(item.meta || {}));
  if (found) found.qty += item.qty || 1;
  else items.push({ ...item, qty: item.qty || 1 });
  save(items);
};

export const updateQty = (idx, qty) => {
  const items = getCart();
  if (!items[idx]) return;
  items[idx].qty = Math.max(1, qty);
  save(items);
};

export const removeItem = (idx) => {
  const items = getCart();
  items.splice(idx, 1);
  save(items);
};

export const clearCart = () => save([]);
